import React, { useState } from 'react';

const todayOrders = [
  {id:'ORD001',customer:'Rajesh Kumar',phone:'9876543210',items:['Dolo 650 x2','Metformin x1'],total:105,time:'2:30 PM',status:'pending'},
  {id:'ORD002',customer:'Priya Devi',phone:'9543217890',items:['Vitamin D3 x1','Cetirizine x2'],total:170,time:'2:45 PM',status:'preparing'},
  {id:'ORD003',customer:'Murugan',phone:'9012345678',items:['Amlodipine x1'],total:38,time:'3:00 PM',status:'ready'},
  {id:'ORD004',customer:'Kavitha',phone:'9988776655',items:['Pantoprazole x2'],total:140,time:'3:15 PM',status:'delivered'},
];
const inventory = [
  {id:1,name:'Dolo 650',stock:450,min:50,price:30,category:'காய்ச்சல்',status:'good'},
  {id:2,name:'Metformin 500',stock:35,min:50,price:45,category:'சர்க்கரை',status:'low'},
  {id:3,name:'Amlodipine 5mg',stock:120,min:30,price:38,category:'BP',status:'good'},
  {id:4,name:'Vitamin D3',stock:80,min:20,price:120,category:'வைட்டமின்',status:'good'},
  {id:5,name:'Pantoprazole',stock:18,min:30,price:55,category:'வயிறு',status:'low'},
];
function App() {
  const [screen,setScreen]=useState('login');
  const [tab,setTab]=useState('dashboard');
  const [orders,setOrders]=useState(todayOrders);
  const [shopOpen,setShopOpen]=useState(true);
  const hdr={background:'linear-gradient(135deg,#1a237e,#283593)',padding:'12px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'};
  const btn=(bg='linear-gradient(135deg,#1a237e,#283593)')=>({background:bg,color:'white',border:'none',borderRadius:'8px',padding:'8px 14px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'});
  const navBtn=(t)=>({flex:1,padding:'10px 0',border:'none',background:tab===t?'linear-gradient(135deg,#1a237e,#283593)':'white',color:tab===t?'white':'#666',cursor:'pointer',fontSize:'10px',fontWeight:tab===t?'bold':'normal'});
  const updateStatus=(id,s)=>setOrders(prev=>prev.map(o=>o.id===id?{...o,status:s}:o));
  const statusColor={pending:'#ff9800',preparing:'#1565c0',ready:'#2e7d32',delivered:'#9e9e9e'};
  const statusLabel={pending:'⏳ காத்திருக்கிறது',preparing:'🔄 தயாரிக்கிறது',ready:'✅ தயார்',delivered:'📦 டெலிவரி'};
  const nextStatus={pending:'preparing',preparing:'ready',ready:'delivered'};
  const nextLabel={pending:'🔄 தயாரிக்க தொடங்கு',preparing:'✅ தயார்',ready:'📦 அனுப்பு'};
  const totalRevenue=orders.filter(o=>o.status==='delivered').reduce((a,o)=>a+o.total,0);
  const pendingCount=orders.filter(o=>o.status==='pending').length;
  const lowStock=inventory.filter(i=>i.status==='low').length;
  if(screen==='login') return (
    <div style={{minHeight:'100vh',background:'#e8eaf6',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'white',padding:'40px',borderRadius:'16px',width:'340px',boxShadow:'0 4px 20px rgba(0,0,0,0.1)'}}>
        <div style={{textAlign:'center',marginBottom:'24px'}}>
          <div style={{fontSize:'50px'}}>🏥</div>
          <h2 style={{color:'#1a237e',margin:'8px 0'}}>Vendor Login</h2>
          <p style={{color:'#666',fontSize:'13px'}}>Sashtimedix Pharmacy Portal</p>
        </div>
        <input placeholder="📱 தொலைபேசி எண்" style={{width:'100%',padding:'12px',borderRadius:'8px',border:'2px solid #1a237e',boxSizing:'border-box',marginBottom:'10px',fontSize:'15px'}}/>
        <input type="password" placeholder="🔒 கடவுச்சொல்" style={{width:'100%',padding:'12px',borderRadius:'8px',border:'2px solid #1a237e',boxSizing:'border-box',marginBottom:'16px',fontSize:'15px'}}/>
        <button onClick={()=>setScreen('app')} style={{...btn(),width:'100%',padding:'14px',fontSize:'16px'}}>உள்நுழைய →</button>
      </div>
    </div>
  );
  return (
    <div style={{fontFamily:'sans-serif',maxWidth:'600px',margin:'0 auto',minHeight:'100vh',background:'#f5f5f5',paddingBottom:'60px'}}>
      <div style={hdr}>
        <div>
          <div style={{color:'white',fontWeight:'bold',fontSize:'16px'}}>🏥 Sri Murugan Pharmacy</div>
          <div style={{color:'rgba(255,255,255,0.8)',fontSize:'12px'}}>vendor.sashtimedix.in</div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <span style={{color:'white',fontSize:'12px'}}>{shopOpen?'🟢 திறந்தது':'🔴 மூடியது'}</span>
          <div onClick={()=>setShopOpen(!shopOpen)} style={{width:'44px',height:'24px',borderRadius:'12px',background:shopOpen?'#4caf50':'#9e9e9e',cursor:'pointer',position:'relative'}}>
            <div style={{width:'20px',height:'20px',borderRadius:'50%',background:'white',position:'absolute',top:'2px',left:shopOpen?'22px':'2px',transition:'left 0.3s'}}></div>
          </div>
        </div>
      </div>
      {tab==='dashboard'&&(
        <div style={{padding:'16px'}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'16px'}}>
            {[['💰','இன்று வருமானம்',`₹${totalRevenue}`,'#e8f5e9','#2e7d32'],['📦','நிலுவை ஆர்டர்',`${pendingCount} ஆர்டர்`,'#fff3e0','#e65100'],['✅','டெலிவரி',`${orders.filter(o=>o.status==='delivered').length}`,'#e3f2fd','#1565c0'],['⚠️','குறைவான Stock',`${lowStock}`,'#ffebee','#c62828']].map(([icon,label,val,bg,color],i)=>(
              <div key={i} style={{background:bg,borderRadius:'12px',padding:'14px',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
                <div style={{fontSize:'24px'}}>{icon}</div>
                <div style={{color:'#666',fontSize:'11px'}}>{label}</div>
                <div style={{color:color,fontWeight:'bold',fontSize:'18px'}}>{val}</div>
              </div>
            ))}
          </div>
          <h3 style={{color:'#1a237e',margin:'0 0 12px'}}>📋 இன்றைய ஆர்டர்கள்</h3>
          {orders.map(order=>(
            <div key={order.id} style={{background:'white',borderRadius:'12px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:'6px'}}>
                <span style={{fontWeight:'bold',color:'#1a237e'}}>#{order.id}</span>
                <span style={{background:statusColor[order.status]+'22',color:statusColor[order.status],padding:'3px 10px',borderRadius:'20px',fontSize:'12px',fontWeight:'bold'}}>{statusLabel[order.status]}</span>
              </div>
              <div style={{color:'#333',marginBottom:'3px'}}>👤 {order.customer} | 📱 {order.phone}</div>
              <div style={{color:'#666',fontSize:'12px',marginBottom:'6px'}}>💊 {order.items.join(', ')}</div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <span style={{fontWeight:'bold',color:'#2e7d32',fontSize:'16px'}}>₹{order.total}</span>
                {order.status!=='delivered'&&<button onClick={()=>updateStatus(order.id,nextStatus[order.status])} style={{...btn(),fontSize:'12px',padding:'6px 12px'}}>{nextLabel[order.status]}</button>}
              </div>
            </div>
          ))}
        </div>
      )}
      {tab==='inventory'&&(
        <div style={{padding:'16px'}}>
          <h2 style={{color:'#1a237e',margin:'0 0 16px'}}>💊 கையிருப்பு</h2>
          {lowStock>0&&<div style={{background:'#ffebee',borderRadius:'10px',padding:'12px',marginBottom:'14px',border:'1px solid #ef9a9a'}}><span style={{color:'#c62828',fontWeight:'bold'}}>⚠️ {lowStock} மருந்துகள் குறைவாக!</span></div>}
          {inventory.map(item=>(
            <div key={item.id} style={{background:'white',borderRadius:'12px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div>
                  <div style={{display:'flex',gap:'8px',alignItems:'center',marginBottom:'4px'}}>
                    <span style={{fontWeight:'bold',color:'#1a237e'}}>{item.name}</span>
                    <span style={{background:item.status==='low'?'#ffebee':'#e8f5e9',color:item.status==='low'?'#c62828':'#2e7d32',padding:'2px 8px',borderRadius:'10px',fontSize:'11px',fontWeight:'bold'}}>{item.status==='low'?'⚠️ குறைவு':'✅ சரி'}</span>
                  </div>
                  <div style={{color:'#666',fontSize:'12px'}}>🏷️ {item.category} | ₹{item.price} | Stock: {item.stock}</div>
                </div>
                <button style={{...btn(),fontSize:'11px',padding:'5px 10px'}}>✏️</button>
              </div>
            </div>
          ))}
        </div>
      )}
      {tab==='analytics'&&(
        <div style={{padding:'16px'}}>
          <h2 style={{color:'#1a237e',margin:'0 0 16px'}}>📈 Analytics</h2>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
            {[['💰','வாரம்','₹11,070','#e8f5e9','#2e7d32'],['📦','ஆர்டர்','47','#e3f2fd','#1565c0'],['⭐','Rating','4.8/5','#fff8e1','#f57f17'],['🛵','நேரம்','~25 min','#f3e5f5','#7b1fa2']].map(([icon,label,val,bg,color],i)=>(
              <div key={i} style={{background:bg,borderRadius:'12px',padding:'14px'}}>
                <div style={{fontSize:'24px'}}>{icon}</div>
                <div style={{color:'#666',fontSize:'11px'}}>{label}</div>
                <div style={{color:color,fontWeight:'bold',fontSize:'18px'}}>{val}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {tab==='profile'&&(
        <div style={{padding:'16px'}}>
          <div style={{background:'linear-gradient(135deg,#1a237e,#283593)',borderRadius:'12px',padding:'20px',marginBottom:'16px',color:'white',textAlign:'center'}}>
            <div style={{fontSize:'50px'}}>🏥</div>
            <h2 style={{margin:'0 0 4px'}}>Sri Murugan Pharmacy</h2>
            <p style={{margin:0,opacity:0.8}}>ஈரோடு | License: TN-ERD-001</p>
          </div>
          <button onClick={()=>setScreen('login')} style={{...btn('linear-gradient(135deg,#c62828,#b71c1c)'),width:'100%',padding:'14px',fontSize:'15px'}}>🚪 வெளியேறு</button>
        </div>
      )}
      <div style={{position:'fixed',bottom:0,left:'50%',transform:'translateX(-50%)',width:'100%',maxWidth:'600px',display:'flex',background:'white',boxShadow:'0 -2px 10px rgba(0,0,0,0.1)',zIndex:100}}>
        {[['📊','Dashboard','dashboard'],['📦','ஆர்டர்','orders'],['💊','Stock','inventory'],['📈','Analytics','analytics'],['🏥','கடை','profile']].map(([icon,label,t])=>(
          <button key={t} onClick={()=>setTab(t)} style={navBtn(t)}><div style={{fontSize:'18px'}}>{icon}</div><div>{label}</div></button>
        ))}
      </div>
    </div>
  );
}
export default App;